import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdresAfbeeldingComponent } from './adres-afbeelding.component';
import { AdresAfbeeldingService } from './adres-afbeelding.service';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        TooltipModule,
        LazyLoadImageModule
    ],
    exports: [
        AdresAfbeeldingComponent
    ],
    declarations: [
        AdresAfbeeldingComponent
    ],
    providers: [
        AdresAfbeeldingService
    ],
})
export class AdresAfbeeldingModule { }
